import type { Company } from '~/api/auth';
import type { RxIconName } from '~/components/ui/Icon';
import { ROUTES } from '~/routes';
import {
  ACCESS_LEVEL,
  type AccessLevel,
  type ModuleKey,
  atLeast,
  companyLevel,
} from '~/session/access';

/** O nível mínimo num módulo da empresa em operação para o atalho aparecer. */
export interface ShortcutRequirement {
  module: ModuleKey;
  level: AccessLevel;
}

export interface DashboardShortcut {
  to: string;
  title: string;
  caption: string;
  icon: RxIconName;
  /** Ausente = sempre visível. */
  requires?: ShortcutRequirement;
}

export const DASHBOARD_SHORTCUTS: readonly DashboardShortcut[] = [
  {
    to: ROUTES.emitir,
    title: 'Emitir NFSe',
    caption: 'Wizard em 4 passos',
    icon: 'flash',
    requires: { module: 'nfse', level: ACCESS_LEVEL.full },
  },
  {
    to: ROUTES.notas,
    title: 'Minhas notas',
    caption: 'Status, PDF, cancelamento',
    icon: 'doc',
    requires: { module: 'nfse', level: ACCESS_LEVEL.read },
  },
  {
    to: ROUTES.documentos,
    title: 'Documentos',
    caption: 'Feed e pastas da empresa',
    icon: 'folder',
    requires: { module: 'documents', level: ACCESS_LEVEL.read },
  },
  {
    to: ROUTES.impostos,
    title: 'Impostos',
    caption: 'Guias em aberto, vencidas e pagas',
    icon: 'ledger',
    requires: { module: 'documents', level: ACCESS_LEVEL.read },
  },
  {
    to: ROUTES.empresa,
    title: 'Dados da empresa',
    caption: 'Cadastro e configurações',
    icon: 'settings',
  },
];

/** Os atalhos que a empresa em operação libera, na ordem da lista; sem empresa, só os livres. */
export function visibleShortcuts(company: Company | undefined): DashboardShortcut[] {
  return DASHBOARD_SHORTCUTS.filter(
    ({ requires }) => !requires || atLeast(companyLevel(company, requires.module), requires.level),
  );
}
